import React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import AddDescriptionForm from './AddDescriptionForm';
import SettingsSectionHeader from '../../settings/SettingsSectionHeader';
import AddVehicleContentWrapper from '../AddVehicleContentWrapper';
import '../../assets/css/componentStyles/FormValidation.css';

const getFieldError = (validationErrors) =>
  validationErrors?.DESCRIPTION?.['descriptionAndSettings.description'] || null;

function AddDescriptionPage({
  form,
  className,
  header = 'Description',
  description = 'Add an accurate detailed description of the vehicle.',
  disabled = false,
  validationErrors = {},
  onValidate,
  saveDraftRef,
  showSuccessAlertRef,
}) {
  const wrapperClassName = classNames(className);
  const descriptionError = getFieldError(validationErrors);

  return (
    <div onBlur={onValidate}>
      <AddVehicleContentWrapper className={wrapperClassName}>
        <SettingsSectionHeader header={header} description={description} />
        <AddDescriptionForm
          form={form}
          disabled={disabled}
          sectionError={descriptionError}
          descriptionError={descriptionError}
          saveDraftRef={saveDraftRef}
          showSuccessAlertRef={showSuccessAlertRef}
        />
      </AddVehicleContentWrapper>
    </div>
  );
}

AddDescriptionPage.propTypes = {
  form: PropTypes.shape({
    values: PropTypes.object,
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
  }).isRequired,
  className: PropTypes.string,
  header: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  validationErrors: PropTypes.object,
  onValidate: PropTypes.func,
};

AddDescriptionPage.defaultProps = {
  className: '',
  header: 'Description',
  description: 'Add an accurate detailed description of the vehicle.',
  disabled: false,
  validationErrors: {},
  onValidate: () => {},
};

export default AddDescriptionPage;
